
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, Icon, Menu} from "antd";
import BaseComponent from "../../../../../../base/BaseComponent";

export default class Jurisdiction extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            Jurisdiction:'权限不限'
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let jurisdictionList = ["权限不限",'可公开下载','需申请下载'];
        let jurisdiction =(
            <Menu style={{marginTop:'7px'}} onClick={({item, key,}) => {
                this.selectMenu( key)
            }}>
                {
                    jurisdictionList.map(optionName =>
                        <Menu.Item  value={optionName} key={optionName}>{optionName}</Menu.Item>
                    )
                }
            </Menu>
        )
        return (
            <Dropdown overlay={jurisdiction} trigger={["click"]} style={{display: 'none'}}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}
                   style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '14px', marginRight: "32px"}}
                >
                    {this.state.Jurisdiction}&nbsp;&nbsp;
                    <Icon type="down"/>
                </a>
            </Dropdown>
        )
    }

    selectMenu(data) {
        this.state.Jurisdiction = data;
        this.setState({});
        if (typeof this.props.onClickCall == "function") {
            this.props.onClickCall([{type:'Jurisdiction', data}])
        }
    };
}